import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
import { commonTitleText } from 'src/modules/utils/constants'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    title={commonTitleText.streamLiveTVSports}
    subtitle={
      <>
        Enjoy a special offer through Student Beans.
        <br />
        Save $30/mo off your first two months.
      </>
    }
    offerCode={promoCodes.student_beans}
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-student-beans.png?w=451&ch=width&auto=format,compress"
    noIndex={true}
  />
)
